import { useEffect } from 'react'
import { useRecoilValueLoadable, useSetRecoilState } from 'recoil'

import { addAlertQuery } from 'services/alert'
import { errorMessage } from 'shared/error-handle'
import { getAsyncProducts, getAsyncSuggests } from './selector'

export const useProducts = () => {
  const productsLoadable = useRecoilValueLoadable(getAsyncProducts)
  const setAlert = useSetRecoilState(addAlertQuery)

  useEffect(() => {
    switch (productsLoadable.state) {
      case 'hasError':
        setAlert([{ message: errorMessage(productsLoadable.contents) }])
        break
      case 'hasValue':
      case 'loading':
      default:
    }
  }, [productsLoadable.state])

  return {
    isLoading: productsLoadable.state === 'loading',
    products: productsLoadable.valueMaybe(),
  }
}

// Deprecated: not used at the moment.
export const useSuggests = () => {
  const suggestsLoadable = useRecoilValueLoadable(getAsyncSuggests)
  const setAlert = useSetRecoilState(addAlertQuery)

  useEffect(() => {
    switch (suggestsLoadable.state) {
      case 'hasError':
        setAlert([{ message: errorMessage(suggestsLoadable.contents) }])
        break
      case 'hasValue':
      case 'loading':
      default:
    }
  }, [suggestsLoadable.state])

  return {
    isLoading: suggestsLoadable.state === 'loading',
    suggests: suggestsLoadable.valueMaybe(),
  }
}
